import { css, unsafeCSS } from 'lit';
import { fsFontWeightSemibold } from '@cof/fs-tokens';

const logo = new URL('assets/background-offer-page.webp', import.meta.url).href;

export const style = css`
  .cancel-button {
    padding-right: 1em;
    padding-bottom: 1em;
  }
  .enter-button {
    padding-bottom: 1em;
  }

  .confirm-button {
    display: flex;
    justify-content: center;
    padding-top: 1em;
  }

  .promo-header-column {
    flex-grow: 2;
    padding-left: 1em;
  }

  .continue-without-code-button {
    padding: 1.5em;
  }

  .editPrefillAccessCode {
    padding-top: 1em;
    padding-right: 1em;
    padding-left: 1em;
  }

  .wrapper {
    display: flex;
    padding-top: 1em;
    padding-bottom: 1em;
    padding-right: 1em;
    padding-left: 1em;
  }

  .edit-button {
    background: none;
    border: none;
    display: flex;
    float: right;
  }

  .title-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: center;
  }

  .access-code-title-text {
    font-weight: ${unsafeCSS(fsFontWeightSemibold)};
    text-align: left;
  }

  .icon-and-title {
    display: flex;
    gap: 1em;
    align-items: center;
  }

  .spinner-container > * {
    display: flex;
    padding-top: 3em;
    padding-bottom: 19em;
    justify-content: center;
  }

  @media only screen and (max-width: 744px) {
    .update-button-container {
      flex-direction: column;
    }
  }

  .button-container {
    padding-top: 1em;
    text-align: right;
  }

  .mudflap .icon-and-title {
    display: flex;
    gap: 0.5em;
  }

  .connected-entry-header {
    padding: 1.5em;
  }

  .connected-entry-logo {
    background-position: center top;
    text-align: center;
    padding-top: 1.5em;
    padding-right: 1.5em;
    padding-left: 1.5em;
  }

  .hdr-text {
    margin-bottom: 0.5em;
  }

  @media (min-width: 48em) {
    .cont {
      max-width: 30rem;
      flex-direction: column;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 48em) {
    .cont {
      margin-left: 1.5em;
      margin-right: 1.5em;
    }
  }

  @media (min-width: 36em) {
    .cont-connected-entry {
      max-width: 33rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 36rem) {
    .cont-connected-entry {
      max-width: 33rem;
      margin-left: 1.5em;
      margin-right: 1.5em;
    }
  }

  .form-field-connected-entry {
    margin-bottom: 1em;
    margin-top: 1em;
  }

  .connected-entry-button {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5em;
  }

  .img-header {
    background: url(${unsafeCSS(logo)}) 44% 50% no-repeat;
    background-color: #879199;
    background-position: center top;
    background-size: contain;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 2em;
    @media (min-width: 48em) {
      background-position: 44% 50%;
      background-size: cover;
    }
    @media (min-width: 64em) {
      grid-template-columns: 1fr 20em 20em 20em 1fr;
    }
  }
  .header-content {
    background-color: hsl(0, 0%, 100%, 80%);
    grid-column: 1/5;
    margin: 10em 0.5em 1em;
    padding: 1.5em;
    text-align: center;
    @media (min-width: 48em) {
      grid-column: 1/3;
      margin: 3em 1em;
    }
    @media (min-width: 64em) {
      grid-column: 2/4;
    }
  }
  .hdr-text {
    margin-bottom: 0.5em;
  }

  .form-field {
    margin-bottom: 1em;
  }
  .button {
    display: flex;
    justify-content: center;
    margin-bottom: 2em;
  }

  @media (min-width: 3rem) {
    .form-button {
      min-width: 100%;
    }
  }

  @media (min-width: 38rem) {
    .form-button {
      min-width: 5.5rem;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .link {
    margin-bottom: 3em;
    text-align: center;
  }
`;
